import axios from 'axios';

let url = '';

export const initListService = (config: Record<string, any>) => {
    url = config.rulesUrl;
};

export interface ListNamesDictionary {
    [key: string]: string;
}

export const getListNames = async () => {
    const res = await axios.get<ListNamesDictionary>(`${url}/list/names`);
    return res.data;
};

export const getListTypes = async () => {
    const res = await axios.get<ListTypes>(`${url}/list/listTypes`);
    return res.data;
};

export const getListForListManagement = async (params: ListGetParams) => {
    if (!params.showLists) {
        return new Promise((resolve) => {
            resolve({
                total: 0,
                result: [],
                listIdHashMap: {}
            });
        }) as Promise<ListApiGetResponse>;
    }

    const res = await axios.get<ListApiGetResponse>(`${url}/list`, { params });
    return res.data;
};

export const postList = async (data: List) => {
    return axios.post<List>(`${url}/list`, { ...data });
};

export const patchList = async (id: number, data: PatchList) => {
    return axios.patch<PatchList>(`${url}/list/${id}`, { ...data });
};

export const getListById = async (id: number, params: { templateRepositoryId: number }) => {
    const res = await axios.get<ListManagementApiList>(`${url}/list/${id}`, { params });
    return res.data;
};

export const deleteList = async (listId: number, params: { templateRepositoryId: number }) => {
    return axios.delete(`${url}/list/${listId}`, { params });
};
